import { Box, Grid, IconButton, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect } from "react";
import { UpgradeDialogSource } from "schemas/dashboard";

import BannerWrapper from "../BannerWrapper";
import { useCountDown } from "../useCountdown";

const BlackFridayPromo = () => {
  const { subscription, setUpgradeDialogSource } =
    useContext(SubscriptionContext);
  const { display, createTimer } = useCountDown();

  useEffect(() => {
    createTimer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return display ? (
    <BannerWrapper
      onClick={() => setUpgradeDialogSource(UpgradeDialogSource.black_friday)}
    >
      <Grid container alignItems={"center"} justifyContent={"center"}>
        <Typography
          sx={{ fontSize: { xs: 10, md: 14, color: "white" } }}
          textAlign="center"
        >
          🔥 Black Friday: Only <strong>{display} Left!</strong> Save{" "}
          {subscription?.bannerPromoCode?.discountPercent}% &{" "}
          <strong>FREE EMAIL TEMPLATE</strong> on annual plans
        </Typography>

        <IconButton sx={{ fontSize: 14 }}>
          <Box
            component="i"
            className="fa-regular fa-arrow-right"
            sx={{ color: "white" }}
          />
        </IconButton>
      </Grid>
    </BannerWrapper>
  ) : (
    <></>
  );
};

export default BlackFridayPromo;
